const dsProduct = (($) => {

    let incrementTimer,
        qvHidden;
    const product_div = 'div.product-card',
        qv_div = 'div.prod-quickview-modal',
        cart_div = 'div.product',
        cart_quantity = 'input.cart-quantity',
        product_detail_div = 'div#main-container',
        product_link = 'a.site-product-link',
        details_div = 'div.details',
        grid_item = 'div.grid-item',
        button_add = 'button.add-to-cart',
        item_rows = 'div.add-deduct-item-row',
        modal_orders = 'div.order-modal',
        real_time = 'div#postcode-banner';

    function loadPage(source, id = 0) {
        const details_page = $(product_detail_div).hasClass('product-details');
        setKeys(details_page);
        setAddToCart();
        setIncrementButtons();
        setProductButtons(source, id);
        setAddToFave();
        setAddToList();
        setQV(source);
        dsCart.loadCart();
    }

    function setKeys(details_page) {
        $(product_div).each(function (i) {
            $(this).attr('data-key', details_page ? i + 1 : i);
        });
        $(qv_div).each(function (i) {
            $(this).attr('data-key', details_page ? i + 1 : i);
        });
    }

    function setAddToCart() {
        $(button_add).off('click').on('click',function() {
            addToCart($(this), 0);
        });
    }

    function setIncrementButtons() {
        $('button.green-btn.deduct, button.green-btn.add, button.orange-btn2.deduct, button.orange-btn2.add').off('click').on('click', function() {
            const that = doorstep.mode === 'edit' ? getThis(this) : $(this),
                q = getQuantity(that);
            clearTimeout(incrementTimer);
            incrementTimer = setTimeout(function() {
                doIncrement(that, 'product', true);
                addToCart(that, q, true);
            }, doorstep.doneIncrementInterval, $(this));
        });
    }

    function getThis(el) {
        const act = $(el).hasClass('add') ? 'add' : 'deduct',
            product = getCartProduct(el);
        const key = getCartKey(act, product, el)
        if (key >= 0) {
            return $(`div.cart button.${act}`).eq(key);
        }
        return el;
    }

    function getCartKey(act, product, el) {
        if (act === 'add' && dsCart.priceChanged(product)) {
            if (product.edit_in_cart < product.inventory_reserved) {
                return doorstep.cart_products.findIndex(prod => prod.id == product.id);
            }
            return doorstep.cart_products.findIndex(prod => prod.id == product.id && prod.price == prod.edit_price);
        }
        if (dsUtilities.getView(el) === 'cart') {
            return el;
        }
        return doorstep.cart_products.reduce((acc, prod, index) => (
            prod.id == product.id ? index : acc
        ), -1);
    }

    function getCartProduct(el) {
        if (dsUtilities.getView(el) === 'cart') {
            return doorstep.cart_products[dsUtilities.getKey(el)];
        }
        const cat_product = getProduct(el);
        return doorstep.cart_products.find(prod => cat_product.id == prod.id);
    }

    function setProductButtons(source, id = 0) {
        if (source !== 'cart') {
            $(item_rows).each(function () {
                const product = getProduct(this);
                productButtonChange($(this), product.in_cart > 0 || product.id === id ? 'incart' : 'box');
            });
        }
    }

    function setAddToFave() {
        $(`${product_div} > img.fav, ${qv_div} img.fav-add-prod-info, ${product_detail_div} img#fav-add-prod-details`).off('click').on('click', function() {
            const el = $(this),
                action = $(el).attr('src').endsWith('fav_small.svg') || $(el).attr('src').endsWith('fav_large.svg') ? 'add' : 'remove';
            addToFav(el, action).done(function(response) {
                if (!response.error) {
                    dsUtilities.doModal('fave', response.message);
                    changeFavImages(el, action);
                }
            });
        });
    }

    function setAddToList() {
        $(`${product_div} > img.list, ${product_detail_div} img#list-add-prod-details`).off('click').on('click', function() {
            dsList.modalOpen(this, 'product');
        });
    }

    function updateViewed(id) {
        $.ajax({
            url: 'index.php?route=product/product/update_viewed',
            type: 'post',
            data: { id: id }
        });
    }

    function setQV(source) {
        if (source !== 'cart') {
            $(qv_div).each(function (i) {
                const el = $(this),
                    item = getQVWrapper(el, i);
                $(el).attr('data-key', i);
                $(item).find('img.look').off('click').on('click', function () {
                    const product = getProduct($(this));
                    if (product.id !== undefined) {
                        const image_div = $(el).find('div.qv-img');
                        if ($(image_div).html() === '') {
                            const image = $(el).attr('data-img');
                            if (image !== '') {
                                $(image_div).html(`<img src="/image/${image}" class="product-img" alt"${product.name}" />`);
                            }
                        }
                        let url = $(item).find('a').attr('href'),
                            params = new URLSearchParams(url.substring(url.indexOf('?') + 1));
                        dsSEO.klaviyoViewedProduct(product);
                        dsSEO.gtmProductView(product);
                        updateViewed(product.id);
                    }
                    $(el).css('display', 'block');
                    let ids = [], values = [];
                    doorstep.cart_products.forEach(function (cart_product) {
                        ids.push(cart_product.id);
                        values.push(cart_product.in_cart);
                    });
                    $($(el).find(item_rows)).each(function () {
                        const prod = getProduct(this),
                            id = prod.id,
                            add_to_box = $(this).closest(details_div).find(button_add),
                            input = $(this).find('input.number2');
                        if (ids.includes(id)) {
                            $(input).val(values[ids.indexOf(id)]);
                            $(this).removeClass('hide');
                            $(add_to_box).addClass('hide');
                        } else {
                            $(input).val(prod.quantity_start);
                            $(this).addClass('hide');
                            $(add_to_box).removeClass('hide');
                        }
                    });
                });
                $(getQVClose(el, item, i)).off('click').on('click', function () {
                    const div = $(product_div).eq(i);
                    $(el).find(details_div).each(function (key) {
                        if ($(this).find(button_add).hasClass('hide')) {
                            $(div).find(button_add).eq(key).addClass('hide');
                            $(div).find(item_rows).eq(key).removeClass('hide');
                        } else {
                            $(div).find(button_add).eq(key).removeClass('hide');
                            $(div).find(item_rows).eq(key).addClass('hide');
                        }
                    });
                    $(qv_div).css('display', 'none');
                    $(qv_div).find('div.product-message').html('');
                });
            });
        }
    }

    function getQVWrapper(el, i) {
        if ($(el).hasClass('quickview-related')) {
            return $(`div.slider__item:eq(${i})`);
        }
        return $(el).closest(grid_item);
    }

    function getQVClose(el, item, i) {
        if ($(el).hasClass('quickview-related')) {
            item = $(`div.quickview-wrapper:eq(${i})`);
        }
        return $(item).find('img.prod-quickview');
    }

    function changeFavImages(el, action) {
        const view = dsUtilities.getView(el);
        let images = ['fav_small', 'fav_large'];
        if (view === 'qv') {
            images.reverse();
        }
        $(el).attr('src', '/dist/images/' + (action === 'add' ? images[0] + '_selected.svg' : images[0] + '.svg'));
        $(el).closest(grid_item).find((view === 'product' ? qv_div : product_div) + ' img.' + (view === 'product' ? 'fav-add-prod-info' : 'fav')).attr('src', '/dist/images/' + (action === 'add' ? images[1] + '_selected.svg' : images[1] + '.svg'));
    }

    function addToFav(el, action, product_obj = '') {
        const product = product_obj instanceof Object ? product_obj : getProduct(el);
        return $.ajax({
            url: 'index.php?route=account/wishlist/' + action,
            type: 'post',
            data: { product_id: product.id, quantity: product.quantity_start },
            dataType: 'json'
        });
    }

    function getProduct(el) {
        const type = dsUtilities.getType(el),
            key = getKey(el),
            product = !isChildProduct(el) ? doorstep[type][key] : doorstep[type][key]['child_products'][getChildKey(el)];
        product.date_next = moment(product.date_next, 'YYYY-MM-DD');
        product.date_to = moment(product.date_to, 'YYYY-MM-DD');
        product.date_unlimited = moment(product.date_unlimited, 'YYYY-MM-DD');
        product.run_date = !doorstep.saved_run_date.length ?  moment().add(1, 'days').startOf('day') : moment(doorstep.saved_run_date, 'YYYY-MM-DD');
        return product;
    }

    function getProductIndex(id) {
        return (
            doorstep.products.findIndex(function(product) {
                return product.id === id;
            })
        )
    }

    function updateInCart(id, quantity) {
        if (doorstep.products !== undefined) {
            if (isProductPage()) {
                const product = doorstep.products[0];
                if (product.id === id) {
                    doorstep.products[0]['in_cart'] = quantity;
                    setQuantity($(button_add).eq(0), quantity);
                } else {
                    product.child_products.forEach(function (prod, key) {
                        if (prod.id === id) {
                            doorstep.products[0]['child_products'][key]['in_cart'] = quantity;
                            setQuantity($(button_add).eq(key + 1), quantity);
                        }
                    });
                }
                let num = 0;
                doorstep.products.forEach(function (product, key) {
                    if (key > 0) {
                        if (product.id === id) {
                            doorstep.products[key]['in_cart'] = quantity;
                            setQuantity(getProductDivByKey( key - 1), quantity);
                        }
                        num++;
                        product.child_products.forEach(function (child_product, child_key) {
                            if (child_product.id === id) {
                                doorstep.products[key]['child_products'][child_key]['in_cart'] = quantity;
                                setQuantity(getProductDivByKey(num, 'child'), quantity);
                            }
                            num++;
                        });
                    }
                });
            } else {
                let num = 0;
                doorstep.products.forEach(function (product, key) {
                    if (product.id === id) {
                        doorstep.products[key]['in_cart'] = quantity;
                        setQuantity(getProductDivByKey(key), quantity);
                    }
                    num++;
                    product.child_products.forEach(function (child_product, child_key) {
                        if (child_product.id === id) {
                            doorstep.products[key]['child_products'][child_key]['in_cart'] = quantity;
                            setQuantity(getProductDivByKey(num, 'child'), quantity);
                        }
                        num ++;
                    });
                });
            }
        }
    }

    function isProductPage() {
        return $('div.product-details').length > 0;
    }

    function message(el, message) {
        const div = getElement(el),
            view = dsUtilities.getView(el);
        if (!div || div.length) {
            const msg = view === 'order-info' ? $(el).closest('div.item').find('div.product-message') : $(div).find('div.product-message'),
                reload = !$(msg).html().length && view ===  'product';
            $(msg).html(message);
            if (message.length > 0) {
                $(msg).removeClass('hide');
                if (reload) {
                    masonryReload();
                }
            } else {
                $(msg).addClass('hide')
            }
        }
    }

    function hasMessage(el) {
        const div = getElement(el);
        if (!div || div.length) {
            return $(div).find('div.product-message').html().length > 0;
        }
        return false;
    }

    function masonryReload() {
        const grid = $('.grid');
        grid.masonry('reloadItems');
        grid.masonry();
    }

    function getElement(el) {
        const view = dsUtilities.getView(el),
            key = getKey(el);
        if (view === 'product_detail' || view === 'qv') {
            return $('div.price-list');
        }
        if (view === 'product') {
            return $('div.product-card').eq(isProductPage() ? key - 1 : key);
        }
        if (view === 'cart') {
            return $(`div#my-box div.product[data-key="${key}"]`);
        }
        return false;
    }

    function doIncrement(el, source, check, prod = []) {
        if (source !== 'shopping-list') {
            message(el, '');
        }
        const product = prod.id !== undefined ?  prod : getProduct($(el)),
            direction = $(el).hasClass('deduct') ? 'down' : 'up',
            increments = incrementsArray(product.increments),
            last = increments[increments.length-1],
            packing = direction === 'down' && (doorstep.editstatus === 4 || doorstep.editstatus === 20),
            multiple = dsCart.priceChanged(product);
        let q = multiple ? product.in_cart : getQuantity(el),
            pos = increments.indexOf(q),
            inc = true;
        if (!increments.length) {
            q = direction === 'up' ? q + 1 : (q < 2 ? 1 : q - 1);
        } else {
            if (pos === -1 && q < last) {
                let prev = 0;
                $(increments).each(function (k, v) {
                    if (q >= prev && q <= v) {
                        pos = k > 0 ? k - 1 : 0;
                        return false;
                    }
                    prev = v;
                });
            }
            if (direction === 'up') {
                pos++;
                q = q >= last ? q + 1 : increments[pos];
            } else {
                pos--;
                q = pos === -1 ? q : (q >= last ? q - 1 : increments[pos]);
            }
            if (packing && q < product.inventory_reserved && product.inventory_reserved !== 0) {
                q = getQuantity(el);
            }
        }
        if (check) {
            const availability = dsAvailability.checkAvailability(product, q);
            if (!availability.success) {
                inc = false;
                message(el, availability.message);
            }
        }
        if (inc) {
            setQuantity(el, q);
        }
    }

    function getKey(el) {
        const view = dsUtilities.getView(el);
        if (view === 'order-info') {
            return 0;
        }
        return parseInt($(el).closest(getViewDiv(view)).attr('data-key'));
    }

    function getViewDiv(view) {
        switch(view) {
            case 'qv':
                return qv_div;
            case 'product':
                return product_div;
            case 'cart':
                return cart_div;
            case 'product_detail':
                return product_detail_div;
        }
    }

    function getChildKey(el) {
        return parseInt($(el).closest(details_div).attr('data-key'));
    }

    function getQuantity(el) {
        const view = dsUtilities.getView(el);
        if (view === 'product') {
            return parseFloat($(el).closest(details_div).find(cart_quantity).val());
        }
        if (view === 'product_detail' || view === 'qv') {
            return parseFloat($(el).closest('div.item').find(cart_quantity).val());
        }
        if (view === 'shopping-list') {
            return parseFloat($(el).closest(details_div).find('p.shopping-list-quantity').html());
        }
        return parseFloat($(el).closest(details_div).find('p.cart-quantity').html());
    }

    function setQuantity(el, quantity) {
        const view = dsUtilities.getView(el);
        if (['product', 'product_detail','qv'].includes(view)) {
            $(el).closest(details_div).find(cart_quantity).val(quantity);
            if (['product', 'qv'].includes(view)) {
                const div = $(el).closest(grid_item).find(view === 'product' ? qv_div : product_div);
                $(div).closest(details_div).find(cart_quantity).val(quantity);
            }
            if (view === 'product_detail') {
                $('div.product-carousel').find(cart_quantity).val(quantity);
            }
        }
        if (view === 'shopping-list') {
            doorstep.list_product.quantity = quantity;
            $(el).closest(details_div).find('p.shopping-list-quantity').html(quantity);
        }
        $(el).closest(details_div).find('p.cart-quantity').html(quantity);
    }

    function isChildProduct(el) {
        return $(el).hasClass('child');
    }

    function getProductDivByKey(key, type) {
        let div = `${product_div} ${button_add}`;
        if (type === 'child') {
            return $(div).eq(key);
        }
        return $(`${div}:not(.child)`).eq(key);
    }

    function resetButtons(id  = 0) {
        if (doorstep.products !== undefined) {
            if (isProductPage()) {
                const product = doorstep.products[0],
                    divs = $(button_add);
                if (id === product.id || !id)  {
                    productButtonChange($(divs).eq(0), 'box');
                    setQuantity($(divs).eq(0), product.quantity_start);
                    doorstep.products[0].in_cart = 0;
                }
                product.child_products.forEach(function (child_product, key) {
                    if (child_product.id === id || !id) {
                        productButtonChange($(divs).eq(key + 1), 'box');
                        setQuantity($(divs).eq(key + 1), child_product.quantity_start);
                        doorstep.products[0].child_products[key].in_cart = 0;
                    }
                });
                let num = 0;
                doorstep.products.forEach(function (product, key) {
                    if (key > 0) {
                        if (product.id === id || !id) {
                            const div = getProductDivByKey(key - 1);
                            productButtonChange(div, 'box');
                            setQuantity(div, product.quantity_start);
                            message(div, '');
                            doorstep.products[key].in_cart = 0;
                        }
                        num++;
                        product.child_products.forEach(function (child_product, key2) {
                            if (child_product.id === id || !id) {
                                const div = getProductDivByKey(num, 'child');
                                productButtonChange(div, 'box');
                                setQuantity(div, child_product.quantity_start);
                                doorstep.products[key].child_products[key2].in_cart = 0;
                            }
                            num++;
                        });
                    }
                });
            } else {
                let num = 0;
                doorstep.products.forEach(function (product, key) {
                    if (product.id === id || !id) {
                        const div = getProductDivByKey(key);
                        productButtonChange(div, 'box');
                        setQuantity(div, product.quantity_start);
                        message(div, '');
                        doorstep.products[key].in_cart = 0;
                    }
                    num++;
                    product.child_products.forEach(function (child_product, key2) {
                        if (child_product.id === id || !id) {
                            const div = getProductDivByKey(num, 'child');
                            productButtonChange(div, 'box');
                            setQuantity(div, child_product.quantity_start);
                            doorstep.products[key].child_products[key2].in_cart = 0;
                        }
                        num++;
                    });
                });
            }
        }
    }

    function productButtonChange(el, type) {
        let [show, hide] = [item_rows,  button_add];
        if (type === 'box') {
            [show, hide] = [hide, show];
        }
        const div = $(el).parents(details_div);
        $(div).find(show).removeClass('hide');
        $(div).find(hide).addClass('hide');
    }

    function incrementsArray(increments) {
        if (increments === '' || increments === '0.00') {
            return [];
        } else {
            let arr = increments.split(':');
            for (let i = 0; i < arr.length; i++) {
                arr[i] = parseFloat(arr[i]);
            }
            return arr;
        }
    }

    function ordersModalOpen(el) {
        if (dsUtilities.getView(el) === 'qv') {
            qvHidden = getKey(el);
            $(el).closest(qv_div).fadeOut(500);
        }
        $(modal_orders).removeClass('hide');
        $('div.existing-order').remove();
        let html = '';
        doorstep.editable_orders.forEach(function (order) {
            html += `<div class="existing-order">
                <div class="details">${order.name}</div>
                <button class="green-btn btn" id="modal-order-edit" data-id="${order.id}" data-type="${order.type}">Add to this order</button>
            </div>`;
        });
        $(html).insertAfter('#modal-order-hr');
    }

    function ordersModalClose() {
        if (qvHidden !== undefined && qvHidden != '' && qvHidden >= 0) {
            $(`${qv_div}[data-key=${qvHidden}]`).fadeIn(500);
            qvHidden = '';
        }
        $(modal_orders).addClass('hide');
    }

    function ordersModalEdit(el) {
        const id = $(el).data('id');
        if ($(el).attr('data-type') === 'order') {
            location.href = dsUtilities.urlEdit() + `/edit&order_id=${id}&product=${doorstep.add_to_cart.product.id}&quantity=${doorstep.add_to_cart.quantity}`;
        } else {
            location.href = `index.php?route=account/account/create_recurring&order_id=${id}&cart=0&product=${doorstep.add_to_cart.product.id}&quantity=${doorstep.add_to_cart.quantity}`;
        }
    }

    function addToCart(el, in_cart, availChecked = false, product_obj = '') {
        const product_supplied =  product_obj instanceof Object,
            product = product_supplied ? product_obj : getProduct(el),
            q = getQuantity(el);
        doorstep.add_to_cart.el = el;
        doorstep.add_to_cart.product = product;
        doorstep.add_to_cart.quantity = q > 0 ? q : (product.quantity_start > 0 ? product.quantity_start : 1);
        doorstep.add_to_cart.in_cart = in_cart;
        if (dsCart.priceChanged(product)) {
            doorstep.add_to_cart.in_cart = product.in_cart;
        }
        if (doorstep.run_asked) {
            if (!doorstep.cart_count && doorstep.editable_orders.length > 0) {
                ordersModalOpen(el);
            } else {
                dsCart.addToCartProcess(availChecked, product_supplied ? 0 : $(el).closest('div.product').attr('data-key'));
            }
        } else {
            dsRuns.openModal();
        }
    }

    function qaOpen(el) {
        $(el).next().slideToggle(300);
        $(el).find('svg').toggleClass('rotate');
        $(el).find('.question').toggleClass('active');
    }

    function qaClose(el) {
        $(el).parent().slideUp(300);
        $(el).parent().prev().find('svg').toggleClass('rotate');
        $(el).parent().prev().find('.question').toggleClass('active');
    }

    function readMore() {
        $('div.truncate-text').toggleClass('reveal-text');
        $('.read-more').css({'display':'none','opacity':'0'});
        $('.read-less').css({'display':'block','opacity':'1'});
    }

    function readLess() {
        $('div.truncate-text').toggleClass('reveal-text');
        $('.read-less').css({'display':'none','opacity':'0'});
        $('.read-more').css({'display':'block','opacity':'1'});
    }

    $(document).ready(function() {

        $(product_detail_div + ' img#share-prod-details').on('click', function() {
            dsUtilities.shareOpen('Share this Shopping List', location.href);
        });
        loadPage('products');

        $(`${modal_orders} img.close-modal`).on('click', function () {
            ordersModalClose();
        });

        $('button#modal-order-add').on('click', function () {
            ordersModalClose();
            dsCart.addToCartProcess(false);
        });

        $(document).on('click', 'button#modal-order-edit', function () {
            ordersModalEdit($(this));
        });

        $(`${real_time} button.orange-btn`).on('click', function () {
            dsRuns.openModal();
        });

        $('div#QA .accordion').on('click', function() {
            qaOpen(this);
        });

        $('div#QA  a.close').on('click', function() {
            qaClose(this);
        });

        $('div.read-more').on('click', function() {
            readMore();
        });
        $('div.read-less').on('click', function() {
            readLess();
        });

    });

    return {
        loadPage            : loadPage,
        doIncrement         : doIncrement,
        productButtonChange : productButtonChange,
        updateInCart        : updateInCart,
        message             : message,
        hasMessage          : hasMessage,
        resetButtons        : resetButtons,
        getProduct          : getProduct,
        getProductIndex     : getProductIndex,
        addToFav            : addToFav,
        addToCart           : addToCart,
        getProductDivByKey  : getProductDivByKey,
        getKey              : getKey,
        getViewDiv          : getViewDiv
    }
})(jQuery);